import { useTheme as useNextTheme } from "next-themes";

export type ThemeName = "light" | "dark";

/**
 * Narrowed hook around next-themes.
 *
 * `resolvedTheme` is always a concrete "light" | "dark" after mount
 * (system preference resolved). During the first render it may be
 * undefined — components should treat that as "unknown" and avoid
 * rendering theme-dependent assets until it's set, to prevent hydration
 * mismatches.
 */
export function useBrandTheme() {
  const { forcedTheme, resolvedTheme, setTheme, systemTheme, theme } = useNextTheme();

  const current = (forcedTheme ?? resolvedTheme ?? theme ?? systemTheme) as ThemeName | undefined;

  const toggle = () => {
    setTheme(current === "dark" ? "light" : "dark");
  };

  return {
    theme: current,
    setTheme: (next: ThemeName) => setTheme(next),
    toggle,
    isDark: current === "dark",
    isLight: current === "light",
  };
}
